import React, { useState } from 'react';
import { Header, Sidebar } from '@components/layout';
import { AppRoutes } from './router';
import { colors } from '@theme/colors';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        isMenuOpen={sidebarOpen}
      />
      <div style={{ display: 'flex', flex: 1 }}>
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main
          style={{
            flex: 1,
            background: colors.neutral.gray100,
            minHeight: 'calc(100vh - 60px)',
            overflow: 'auto',
          }}
        >
          <AppRoutes />
        </main>
      </div>
    </div>
  );
}

export default App;
